<template>
  <div class="selectionInstance pointer">
    <NavBar title="选择授权云手机" />
    <div class="main">
      <div v-if="emptyShow">
        <div
          v-for="item in instancelist"
          :key="item.id"
          @click="handleAuthorizeId(item)"
        >
          <div class="shebei_title">
            <div class="shebei_content">
              <p class="p1">
                <span class="deviceType">{{
                  getDeviceType(item.vipCode, item.deviceVersionCode)
                }}</span>
                {{ item.instanceName }}
              </p>
              <div class="p2">
                <img class="idIcon" src="@/assets/imgs/ID.png" alt="" />
                <p class="id">{{ item.id }}</p>
              </div>
            </div>
            <div class="instanceItem">剩余时间：{{ item.timeRemaining }}</div>
          </div>
        </div>
      </div>
      <van-empty
        v-else
        class="custom-image"
        :image="require('@/assets/imgs/empty.png')"
        description="暂时没有可授权的云手机哦！"
      />
    </div>
  </div>
</template>
  
  <script>
import NavBar from "@/components/NavBar.vue";
import { authorizeinstancelist } from "@/api/instance";
import { mapState, mapMutations } from "vuex";
import buyCode from "@/utils/buyCode";
export default {
  name: "SelectionInstance",
  components: {
    NavBar,
  },
  data() {
    return {
      instancelist: [],
      emptyShow: true,
    };
  },

  mounted() {
    this.getauthorizeinstancelist();
  },

  computed: {
    //数组写法
    ...mapState("common", ["authorizeObj"]),
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode) {
          let item = buyCode.deviceIconOptions.find(
            (item) =>
              item.vipCode == vipCode &&
              item.deviceVersionCode == deviceVersionCode
          );
          if (item) {
            return item.deviceType;
          } else {
            if (deviceVersionCode) {
              return `定制${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },
  methods: {
    ...mapMutations("common", ["SET_AUTHORIZEOBJ"]),
    // 获取可授权设备列表
    getauthorizeinstancelist() {
      authorizeinstancelist()
        .then((res) => {
          if (res.code == 200) {
            this.instancelist = res.data;
            if (this.instancelist.length <= 0) {
              this.emptyShow = false;
            }
          }
        })
        .catch((res) => {
          this.emptyShow = false;
        });
    },
    handleAuthorizeId(item) {
      this.SET_AUTHORIZEOBJ(item);
      this.$router.go(-1);
    },
    formatSeconds(totalSeconds) {
      // 计算各时间单位
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      // 生成单位映射
      const units = ["天", "小时", "分"];
      // 构建结果数组
      const parts = [];
      if (days > 0) parts.push(`${days}${units[0]}`);
      if (hours > 0) parts.push(`${hours}${units[1]}`);
      if (minutes > 0 && totalSeconds < 86400)
        parts.push(`${minutes}${units[2]}`);
      // 处理全0情况
      if (parts.length === 0) return `0${units[3]}`;
      return parts.join("");
    },
  },
};
</script>
  
  <style lang="less" scoped>
.selectionInstance {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  padding: 12px 16px 16px 16px;
  .shebei_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    background: #fff;
    margin-bottom: 12px;
    padding: 10px 16px;
    border-radius: 10px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    .shebei_content {
      // margin-left: 16px;
      text-align: left;
      p {
        margin: 0;
        height: 22px;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
      .p1 {
        font-weight: 500;
        font-size: 15px;
        color: #505465;
      }
      .p2 {
        display: flex;
        align-items: center;
        .idIcon {
          width: 20px;
          height: 18px;
          margin-right: 4px;
        }
        .id {
          font-weight: 500;
          font-size: 12px;
          color: #b8bdcc;
        }
      }
    }
    .instanceItem {
      font-weight: 400;
      font-size: 13px;
      color: #a9adb6;
    }
  }
}
</style>